module.exports = __webpack_public_path__ + "img/water_level.1475080d.svg";